<template>
  <div class="table-responsive">
    <div class="d-flex flex-md-row flex-column justify-content-md-between align-items-center">
      <filter-bar @filter="onFilterSet"></filter-bar>
      <novi-produkt @new-produkt="unosProdukta"></novi-produkt>
      <div
      class="vuestic-file-upload-container__field"
        >
 
      <button type="button" class="btn btn-primary btn-micro" @click="DownloadProducts()">
        {{ "Download"}}
      </button>
    </div>
      
      <produkt-file-upload
          :file-types="'.xls, .xlsx, .xlsb'" 
          type="single"
          v-model="single"></produkt-file-upload>
    </div>
    <vuetable
      ref="vuetable"
      :apiUrl="apiUrl"
      :apiMode="apiMode"
      :fields="tableFields"
      :data="tableData"
      :dataTotal="dataCount"
      :dataManager="dataManager"
      :css="css.table"
      data-path="data"
      v-bind:paginationPath="paginationPath"
      :appendParams="moreParams"
      :perPage="brStr"
      :datum="perPage"
      :token="token"
      :site="site"
      v-on:vuetable:cell-clicked="(...args)=>this.prikaziDetalje([args])"
      @vuetable:pagination-data="onPaginationData"
    ></vuetable>

    <div class="d-flex justify-content-center mb-4">
      <vuetable-pagination
        ref="pagination"
        :css="css.pagination"
        :onEachSide="onEachSide"
        @vuetable-pagination:change-page="onChangePage"
      ></vuetable-pagination>
    </div>

    <!-- Modal -->
    <vuestic-modal-produkt
      :show.sync="show"
      v-bind:medium="true"
      ref="largeModalProdukt"
      :okText="potvrdi"
      :cancelText="odustani"
    >
      <div slot="title">{{'Unos produkta'}}</div>
      <div class="form-elements">
        <div class="row">
          <div class="col-md-12"></div>
        </div>
      </div>
    </vuestic-modal-produkt>

    <vuestic-modal-edit-produkt
      :show.sync="show"
      v-bind:medium="true"
      ref="modalProduktEdit"
      :okText="potvrdi"
      :cancelText="odustani"
      :produktd="produkt_data"
    >
      <div slot="title">
        {{'Edit Produkt: '}}
        <span style="color: #4ae387;">{{produkt_data.opis}} </span>
      </div>
      <div class="form-elements">
        <div class="row">
          <div class="col-md-12"></div>
        </div>
      </div>
    </vuestic-modal-edit-produkt>
  </div>
</template>

<script>
import Vue from "vue";
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import LocalData from "./data/local-data";
import DataTableStyles from "./data/data-table-styles";
import FilterBar from "./datatable-components/FilterBar.vue";
import NewProdukt from "./datatable-components/NoviProdukt.vue";
import EditProdukt from "./ProduktEdit.vue";
import router from "../../../router";
import { http } from "../../../../config/config.js";
import { bus } from "../../../../src/main.js";

const originalData = LocalData.data;
Vue.component("novi-produkt", NewProdukt);
Vue.component("vuestic-modal-edit-produkt", EditProdukt);

export default {
  name: "produkt-table",

  components: {
    FilterBar,
    NewProdukt,
    EditProdukt,
    Vuetable,
    VuetablePagination
  },
  props: {
    site: {
      type: String
    },
    token: {
      type: String
    },
    sekcija: {
      type: String
    },
    apiUrl: {
      type: String
    },
    tableFields: {
      type: Array,
      required: true
    },
    onEachSide: {
      type: Number,
      default() {
        return 2;
      }
    },
    apiMode: {
      type: Boolean,
      default() {
        return true;
      }
    },
    data: {
      type: Array
    },
    sortFunctions: {
      type: Object
    },
    paginationPath: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      tableData: LocalData,
      perPage: "",
      brStr: 10,
      colorClasses: {},
      moreParams: {},
      dataCount: 0,
      css: DataTableStyles,
      produkt: {},
      show: true,
      potvrdi: "SAČUVAJ",
      odustani: "ZATVORI",
      produkt_data: {
      proizvodjac:{
        naziv:""
      },
      klasa:{
        naziv:""
      }, 
      program:{
        naziv:""
      }, 
      platforma:{
        naziv:""
      }, 
      veza:""
      },
      // Toasts
      toastText: "",
      toastIcon: "",
      toastPosition: "",
      toastDuration: 2500,
      isToastFullWidth: false,
      className: "",
      single:[]
    };
  },
  mounted() {
    this.onFilterSet(this.$store.state.filter);
    bus.$on("edit-produkt", data => {
      //this.onFilterSet(data.opis);
    });
    bus.$on("novi-produkt", data => {
      //this.onFilterSet(data.opis);
      this.$refs.largeModalProdukt.open();
    });
  },
  beforeDestroy() {
    bus.$off("edit-produkt");
  bus.$off("novi-produkt");
  },
  watch: {},
  methods: {

    unosProdukta() {
      
      //this.$refs.largeModalProdukt.open();
    },
    DownloadProducts(){
      function msToTime(duration) {
           var milliseconds = Math.floor((duration % 1000) / 100),
            seconds = Math.floor((duration / 1000) % 60),
            minutes = Math.floor((duration / (1000 * 60)) % 60),
            hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
            hours = (hours < 10) ? "0" + hours : hours;
            minutes = (minutes < 10) ? "0" + minutes : minutes;
            seconds = (seconds < 10) ? "0" + seconds : seconds;
            return hours + ":" + minutes + ":" + seconds + "." + milliseconds;
          }
      http
        .get(
          "/inventar/downloadproducts" +
            "?token=" +
            this.$store.state.token +
            "&site=" +
            this.$store.state.site,
          {responseType: "blob"}
        )
        .then(res => {
          console.log('response received')
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "downloadProducts_"+msToTime(Date.now())+ ".xlsx");
                document.body.appendChild(link);
                link.click();
        });
    },
    prikaziDetalje: function(args) {
      var niz = args[0];

      if (
        args[0][2].srcElement.cellIndex === undefined &&
        !args[0][2].srcElement.classList.contains("disabled")
      ) {

        if (niz[1].name === "prijem") {
          router.push("/samples/" + args[0][0].id);
        }
        if (niz[1].name === "IZMJENI") {
          console.log('IZMJENI')
          console.log(args[0][0].id)
          this.produkt = args[0][0].id;
         
          this.EditProdukt();
          
          //router.push("/inventar/produkti/edit/" + args[0][0].id);
        }
        if (niz[1].name === "icon") {
          if(this.$store.state.access.level < 1){
            router.push("/evaluation/" + args[0][0].id);
          }           
        }
      }
    },
      EditProdukt() {
      http
        .get(
          "/inventar/readprodukt/" +
            this.produkt +
            "?token=" +
            this.$store.state.token +
            "&site=" +
            this.$store.state.site,
          {}
        )
        .then(res => {
          this.produkt_data = res.data.produkt
          this.$refs.modalProduktEdit.open();
        });
    },
    onFilterSet(filterText, event) { 

      this.filterString = ""

      this.filterString = filterText
      
      if(event != undefined && filterText.trim() != ''){
    

          if (this.apiMode) {
            this.moreParams = {
              filter: filterText
            };
          } else {
            const txt = new RegExp(filterText, "i");
            this.tableData.data = originalData.filter(function(item) {
              return item.name.search(txt) >= 0 || item.email.search(txt) >= 0;
            });
          }
          
          Vue.nextTick(() => this.$refs.vuetable.refresh());



      }else{

        if (this.apiMode) {
          this.moreParams = {
            filter: filterText
          };
        } else {
          const txt = new RegExp(filterText, "i");
          this.tableData.data = originalData.filter(function(item) {
            return item.name.search(txt) >= 0 || item.email.search(txt) >= 0;
          });
        }
        Vue.nextTick(() => this.$refs.vuetable.refresh());
      }
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    dataManager(sortOrder, pagination) {
      let data = this.tableData.data;
      let sortFunctions = this.sortFunctions;

      if (sortOrder.length > 0) {
        data.sort(function(item1, item2) {
          const sortField = sortOrder[0].sortField;
          let fn = sortFunctions[sortField];
          if (fn) {
            return fn(item1[sortField], item2[sortField]);
          }
        });

        if (sortOrder[0].direction === "desc") {
          data.reverse();
        }
      }

      pagination = this.$refs.vuetable.makePagination(data.length);

      return {
        pagination: pagination,
        data: data.slice(pagination.from - 1, pagination.to)
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/toasts";

@media (max-width: 1258px) {
  .pagination-link-btn:first-child,
  .pagination-link-btn:last-child {
    display: none;
  }
  .pagination-link-btn:nth-child(2) {
    border-top-left-radius: $btn-border-radius !important;
    border-bottom-left-radius: $btn-border-radius !important;
  }
  .pagination-link-btn:nth-last-child(2) {
    border-top-right-radius: $btn-border-radius !important;
    border-bottom-right-radius: $btn-border-radius !important;
  }
}

@media (max-width: 576px) {
  .hide-not-focused-btn:not(.focus) {
    display: none;
  }
}

.btn.btn-info {
  text-transform: none;
}
</style>



// WEBPACK FOOTER //
// src/components/inventar/produkti/ProduktTable.vue